import { z } from "zod";
import "./error-map";

export const createPurchaseItemSchema = z.object({
	productId: z.number().int().positive(),
	quantity: z.number().positive(),
	unitPrice: z.number().min(0),
	discountRate: z.number().min(0).max(100).optional().default(0),
	taxRate: z.number().min(0).max(100).optional().default(0),
	discountAmount: z.number().min(0).optional(),
	taxAmount: z.number().min(0).optional(),
	totalAmount: z.number().min(0).optional(),
	notes: z.string().optional(),
});

export const createPurchaseSchema = z.object({
	supplierId: z.number().int().positive().optional(),
	branchId: z.number().int().positive().optional(),
	status: z.string().optional(),
	paymentStatus: z.enum(["pending", "partial", "paid"]).optional(),
	paymentMethod: z.string().optional(),
	shippingAmount: z.number().min(0).optional(),
	notes: z.string().optional(),
	items: z.array(createPurchaseItemSchema).min(1, "validation.itemsRequired"),
	subtotal: z.number().min(0).optional(),
	discountAmount: z.number().min(0).optional(),
	taxAmount: z.number().min(0).optional(),
	totalAmount: z.number().min(0).optional(),
	expectedDeliveryDate: z.string().optional(),
	dueDate: z.string().optional(),
	purchaseDate: z.string().optional(),
});

export type CreatePurchaseItemInput = z.infer<typeof createPurchaseItemSchema>;
export type CreatePurchaseInput = z.infer<typeof createPurchaseSchema>;
